import { useFliptFeature, type FliptFeature } from "~/hooks/useFliptFeature";
import { FLIPT_ROUTE_KEYS } from "~/router/constants";

/**
 * Flipt `project-apps`, gating every project apps surface: the project's Apps
 * section and app pages, and opening a session's HTML artifact as an app. On
 * only where the analysis-agent serves project apps.
 */
export const useProjectAppsFeature = (): FliptFeature =>
  useFliptFeature(FLIPT_ROUTE_KEYS.PROJECT_APPS);
